import { render, staticRenderFns } from "./ComprasreportesIndex.vue?vue&type=template&id=0af33f96&"
import script from "./ComprasreportesIndex.vue?vue&type=script&lang=js&"
export * from "./ComprasreportesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports